import { Box, Chip, Typography } from '@mui/material'
import React from 'react'

const ServicePrintPreference = ({ value = true, onChange = () => { } }) => {
  return (
    <div>
      <Typography variant="body1">
        Choose Print Preference
      </Typography>
      <Box sx={{ display: "flex", gap: 1, mb: 3, mt: 1 }}>
        <Chip
          label="Per Service"
          color={value ? "primary" : "default"}
          onClick={() => onChange(true)}
        />
        <Chip
          label="Per Page"
          color={!value ? "primary" : "default"}
          onClick={() => onChange(false)}
        />
      </Box>
    </div>
  )
}

export default ServicePrintPreference